import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {ExternalLink, useIsMobile} from '@brg/ui';
import {IDesignerLight} from '../../common';
import {DesignerMultipleAuthors, LinkWrapper, ProjectDesignerWrapper} from './styles';
import {ProjectDesignersTooltip} from './ProjectDesignersTooltip';
import {CreateLinkTo} from "../../constants/linkTo";
import {useHistory, useRouteMatch} from "react-router-dom";
import { AupArrowSvg } from './assets/aup';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AppTester } from 'supporting';


/**
 * Пропсы дизайнера
 */
export interface ProjectDesignerNameProps {
    className?: any;
    onSelected?: (identifier: string) => void;
    multipleAuthorsFit?: boolean
    value: IDesignerLight[];
    tooltipOpen?: boolean;
    toggleTooltip?: Function;
    isBlackTheme?: boolean;
    projectType?: string;
}


/**
 *
 * **ProjectDesignerName** - принимает на вход одного дизайнера или массив.
 * Отображает "Дизайнер Имя" или "Несколько авторов" с тултипом, отображающим массив.
 * Шрифт подстраивается под высший размер.
 *
 * @param props
 */
export const ProjectDesignerName: FC<ProjectDesignerNameProps> = ({ value, tooltipOpen, projectType, toggleTooltip, multipleAuthorsFit = true, isBlackTheme }) => {
    const history = useHistory();
    const theme = useTheme();
    const [fistDesigner] = value;
    const [isClosed, setIsClosed] = useState(true);
    const isMobile = useIsMobile();
    const isMap = !!useRouteMatch('/map');
    const { t } = useTranslation()
    const titleRef = useRef<HTMLDivElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const isDafesMapPopUp = AppTester.isGeoDafes() && isMap;
    const isHSEDesign = AppTester.isHSEDesign();
    const isMedia = AppTester.isMediiia();

    const isPresentation = useMemo(() => !!projectType && !!['t-shape', 'fixed-ratio-small', 'fixed-ratio-large']?.includes(projectType), [projectType])

    // @ts-ignore
    const handleFirstDesignerCLick = useCallback((e, isMultiple?: boolean) => {
      e.preventDefault();
      e.stopPropagation();
      if (isMobile) setIsClosed(prev => !prev);
      if (fistDesigner && !isMultiple) {
        history.push(CreateLinkTo.designerNew(fistDesigner))
      }
    }, [fistDesigner, history, isMobile, isClosed])

    const onClickDocument = (event: any) => {
        if (isClosed || titleRef.current?.contains(event.target) || containerRef.current?.contains(event.target)) return;
        setIsClosed(true);
    }

    useEffect(() => {

        if (value.length <= 1 || !isMobile) return;

        document.addEventListener('mousedown', onClickDocument)
        document.addEventListener('touchstart', onClickDocument)

        return () => {
            document.removeEventListener('mousedown', onClickDocument);
            document.removeEventListener('touchstart', onClickDocument);
        }
    }, [onClickDocument, isMobile, value.length])

    const designerNameShortened = useMemo(() => {
        const firstDesignerFullName = fistDesigner?.name + ' ' + fistDesigner?.surName
        return firstDesignerFullName;
    }, [fistDesigner])

    // Если дизайнеров нет, возвращает пустой фрагмент
    if (value.length < 1) {
      return null
    }
    if (value.length === 1) {
        // Если дизайнер один - отобразить его имя
        return (
            <LinkWrapper to={CreateLinkTo.designerNew(fistDesigner)} external target="_self">
                <ProjectDesignerWrapper isBlackTheme={isBlackTheme} isPresentation={isPresentation} isDafesMapPopUp={isDafesMapPopUp} isHSEDesign={isHSEDesign}>
                    {designerNameShortened}
                </ProjectDesignerWrapper>
            </LinkWrapper>
        );
    }

    return (
        // Если дизайнеров много - вывести сообщение об этом и подключить тултип
        <div>
            <ProjectDesignersTooltip
                containerRef={containerRef}
                visible={isMobile ? !isClosed : undefined}
                placement={'bottom-start'}
            target={
                <DesignerMultipleAuthors
                    ref={titleRef}
                    active={!isClosed}
                    isDafesMapPopUp={isDafesMapPopUp}
                    big={!multipleAuthorsFit}
                    severalАuthors
                    className={'white_theme_designer_wrapper'}
                    onClick={e => handleFirstDesignerCLick(e, true)}
                    gx={6}
                    isMedia={isMedia}
                >
                    <div className={'multiple-authors'}>{t("multiple_authors")}</div>
                    <AupArrowSvg fill={theme.projectView.authorArrowIconColor} />
                </DesignerMultipleAuthors>
            }
            items={isMobile && isClosed ? [] : value}
            theming={{
                color: theme.projectView.authorColor
            }}
        />
        </div>
    );
};
import {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {ExternalLink, useIsMobile} from '@brg/ui';
import {IDesignerLight} from '../../common';
import {DesignerMultipleAuthors, LinkWrapper, ProjectDesignerWrapper} from './styles';
import {ProjectDesignersTooltip} from './ProjectDesignersTooltip';
import {CreateLinkTo} from "../../constants/linkTo";
import {useHistory, useRouteMatch} from "react-router-dom";
import { AupArrowSvg } from './assets/aup';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AppTester } from 'supporting';


/**
 * Пропсы дизайнера
 */
export interface ProjectDesignerNameProps {
    className?: any;
    onSelected?: (identifier: string) => void;
    multipleAuthorsFit?: boolean
    value: IDesignerLight[];
    tooltipOpen?: boolean;
    toggleTooltip?: Function;
    isBlackTheme?: boolean;
    projectType?: string;
}


/**
 *
 * **ProjectDesignerName** - принимает на вход одного дизайнера или массив.
 * Отображает "Дизайнер Имя" или "Несколько авторов" с тултипом, отображающим массив.
 * Шрифт подстраивается под высший размер.
 *
 * @param props
 */
export const ProjectDesignerName: FC<ProjectDesignerNameProps> = ({ value, tooltipOpen, projectType, toggleTooltip, multipleAuthorsFit = true, isBlackTheme }) => {
    const history = useHistory();
    const theme = useTheme();
    const [fistDesigner] = value;
    const [isClosed, setIsClosed] = useState(true);
    const isMobile = useIsMobile();
    const isMap = !!useRouteMatch('/map');
    const { t } = useTranslation()
    const titleRef = useRef<HTMLDivElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const isDafesMapPopUp = AppTester.isGeoDafes() && isMap;
    const isHSEDesign = AppTester.isHSEDesign();
    const isMedia = AppTester.isMediiia();

    const isPresentation = useMemo(() => !!projectType && !!['t-shape', 'fixed-ratio-small', 'fixed-ratio-large']?.includes(projectType), [projectType])

    // @ts-ignore
    const handleFirstDesignerCLick = useCallback((e, isMultiple?: boolean) => {
      e.preventDefault();
      e.stopPropagation();
      if (isMobile) setIsClosed(prev => !prev);
      if (fistDesigner && !isMultiple) {
        history.push(CreateLinkTo.designerNew(fistDesigner))
      }
    }, [fistDesigner, history, isMobile, isClosed])

    const onClickDocument = (event: any) => {
        if (isClosed || titleRef.current?.contains(event.target) || containerRef.current?.contains(event.target)) return;
        setIsClosed(true);
    }

    useEffect(() => {

        if (value.length <= 1 || !isMobile) return;

        document.addEventListener('mousedown', onClickDocument)
        document.addEventListener('touchstart', onClickDocument)

        return () => {
            document.removeEventListener('mousedown', onClickDocument);
            document.removeEventListener('touchstart', onClickDocument);
        }
    }, [onClickDocument, isMobile, value.length])

    const designerNameShortened = useMemo(() => {
        const firstDesignerFullName = fistDesigner?.name + ' ' + fistDesigner?.surName
        return firstDesignerFullName;
    }, [fistDesigner])

    // Если дизайнеров нет, возвращает пустой фрагмент
    if (value.length < 1) {
      return null
    }
    if (value.length === 1) {
        // Если дизайнер один - отобразить его имя
        return (
            <LinkWrapper to={CreateLinkTo.designerNew(fistDesigner)} external target="_self">
                <ProjectDesignerWrapper isBlackTheme={isBlackTheme} isPresentation={isPresentation} isDafesMapPopUp={isDafesMapPopUp} isHSEDesign={isHSEDesign}>
                    {designerNameShortened}
                </ProjectDesignerWrapper>
            </LinkWrapper>
        );
    }

    return (
        // Если дизайнеров много - вывести сообщение об этом и подключить тултип
        <div>
            <ProjectDesignersTooltip
                containerRef={containerRef}
                visible={isMobile ? !isClosed : undefined}
                placement={'bottom-start'}
            target={
                <DesignerMultipleAuthors
                    ref={titleRef}
                    active={!isClosed}
                    isDafesMapPopUp={isDafesMapPopUp}
                    big={!multipleAuthorsFit}
                    severalАuthors
                    className={'white_theme_designer_wrapper'}
                    onClick={e => handleFirstDesignerCLick(e, true)}
                    gx={6}
                    isMedia={isMedia}
                >
                    <div className={'multiple-authors'}>{t("multiple_authors")}</div>
                    <AupArrowSvg fill={theme.projectView.authorArrowIconColor} />
                </DesignerMultipleAuthors>
            }
            items={isMobile && isClosed ? [] : value}
            theming={{
                color: theme.projectView.authorColor
            }}
        />
        </div>
    );
};
